import React from 'react';
import classNames from 'classnames';
import useAuth from '../../hooks/use-auth';
import useBlogMenuSettings from '../../hooks/use-blog-menu-settings';
import NotificationsLink from '../link/notifications-link';
import NotificationButton from '../notification-button';
import SearchButton from '../search-button';
import styles from './header-buttons.scss';

export const HeaderButtons: React.FC = () => {
  const { showLoginButton, showSearch } = useBlogMenuSettings();
  const { isAuthenticated } = useAuth();

  return (
    <div className={classNames(styles.container, 'header-buttons')}>
      {showSearch ? renderSearchButton() : null}
      {showLoginButton ? renderNotificationButton(isAuthenticated) : null}
    </div>
  );
};

function renderSearchButton() {
  return (
    <div className={styles.searchButton}>
      <SearchButton />
    </div>
  );
}

function renderNotificationButton(isAuthenticated: boolean) {
  if (isAuthenticated) {
    return (
      <div className={styles.notificationButtonSpacing}>
        <NotificationButton
          component={NotificationsLink}
          iconClassName="blog-button-primary-icon-color"
        />
      </div>
    );
  }
}

export default HeaderButtons;
